import axios, { AxiosError } from "axios";
import { useQuery } from "react-query";
import TagsPaginatedResponse from "../model/TagsPaginatedResponse";
import TagsPaginatedRequest from "../request/TagsPaginatedRequest";
import { isHiddenTag } from "../../utils/hiddenTags";

const TagsPaginatedApiService = async (
  request: TagsPaginatedRequest
): Promise<TagsPaginatedResponse> => {
  const { data } = await axios.get("/employertag/paginated", {
    params: request,
  });
  return data;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useTagsPaginatedApiService = (request: TagsPaginatedRequest) =>
  useQuery<TagsPaginatedResponse, AxiosError>(
    ["TagsPaginatedApiService", ...Object.values(request)],
    () => TagsPaginatedApiService(request),
    {
      keepPreviousData: true,
      select: (data) => ({
        ...data,
        results: data.results.filter((tag) => !isHiddenTag(tag)),
      }),
    },
  );

export default useTagsPaginatedApiService;
